import { IApiScoreResult } from 'affiny-core/modules/api/models/score/score.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const ScoresResource = {
  getScore: (myAboid: string, otherAboid: string) =>
    AffinyEndpoint.Score.url(`/${myAboid}/${otherAboid}/`)
      .get()
      .json<IApiScoreResult>(),
};
